import {IApplePay} from './interfaces/IApplePay';
declare global {
  interface Window {
    ApplePaySession: any;
  }
}

class ApplePay implements IApplePay {
  async canMakePaymentsApplePay(processorType: string) {
    if (window.ApplePaySession) {
      try {
        return await window.ApplePaySession.canMakePayments();
      } catch (error) {
        return false;
      }
    } else {
      return false;
    }
  }

  //ApplePay Web present apple pay UI
  async presentApplePay(
    //ApplePay Web amount
    amount: number,
    countryCode: string,
    //ApplePay Web curreny
    currencyCode: string,
    sandbox: boolean,
    processor: number,
    //ApplePay Web client secret
    _clientSecret: string,
    processorKey?: string,
    merchantId?: string,
  ) {
    return '';
  }

  //ApplePay Web succeed method
  paymentSucceeded(
    //ApplePay Web processor
    processor: number,
    _clientSecretId: string,
    //ApplePay Web amount
    amount: number,
    countryCode: string,
    currencyCode: string,
  ) {}

  paymentFailed(processor: number) {}
}

export default new ApplePay();
